import { Injectable } from '@angular/core';
import { DataService } from '../dataService/data.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'app/core/auth.service';
import { FirebaseHelper } from 'app/helpers/firebase.helper';
import { OnSiteSOP } from 'app/interfaces/client/on-site-sop.interface';

export interface UserClientUpdate {
    key: string;
    clientKey: string;
    clientName: string;
}

@Injectable()
export class ClientService {

    constructor(
        private authService: AuthService, private firestore: AngularFirestore,public dataService: DataService
    ) { 
        console.debug('ClientService: instantiated');
    }


    // Edit Specfic User
    async changeUserLinkedClient(clientKey: string,clientName: string): Promise<UserClientUpdate> {
        var user = this.authService.appUser.userDetail;
        let changes: UserClientUpdate = {
            key: user.key,
            clientKey: clientKey,
            clientName: clientName,
        }
        try {
            const newId = this.firestore.createId();
            changes = FirebaseHelper.convertForFirebase(changes);

            const newDocRef = this.firestore.collection('users').doc(changes.key);

            await newDocRef.update(changes);
            return changes;
        }
        catch (error) {
            console.error('Error changing clients:', error);
            throw error;
        }
    }
    async updateSOP(clientKey: string, sop: OnSiteSOP[]): Promise<void> {
        var user = this.authService.appUser.userDetail;
        let changes = {
            key: clientKey,
            sop: sop,
        };
        try {
            changes = FirebaseHelper.convertForFirebase(changes);
            const newDocRef = this.firestore.collection("clients").doc(changes.key);
            await newDocRef.update(changes);
            console.log("Document successfully updated");
        } catch (error) {
            console.error("Error changing clients:", error);
            throw error;
        }
    }

    // public async linkUserToClient(user: UserDetail, invitationCode: string = '123456', ): Promise<ReqResponse> {

    //     return await this.dataService.getFirestoreDataFromFunctions(this.userService.appUser.userDetail.key, 'clients', 'invitationCode', invitationCode)
    //         .toPromise()
    //         .then(querySnapshot => {

    //             const clientArr: Client[] = this.dataService.querySnapshotToObject(querySnapshot)

    //             if (clientArr && clientArr.length > 0) {
    //                 const client: Client = clientArr[0];
    //                 user.clientKey = client.key;
    //                 // user.clientName = client.name;

    //                 this.dataService.setFireStoreDataFromFunctions(this.userService.appUser.userDetail.key,'users', user)
    //                     .then(() => {
    //                         return {
    //                             success: true,
    //                             message: 'You have been linked to ' + client.name,
    //                         };
    //                     }).catch(error => {
    //                         return {
    //                             success: false,
    //                             error: error,
    //                             message: error.message,
    //                         };
    //                     });
    //             } else {
    //                 return {
    //                     success: false,
    //                     message: 'Incorrect Invitation Code',
    //                 };
    //             }
    //         });
    // }
}
